import { render, staticRenderFns } from "./TimeslotsCrud.vue?vue&type=template&id=224bc234&scoped=true"
import script from "./TimeslotsCrud.vue?vue&type=script&lang=js"
export * from "./TimeslotsCrud.vue?vue&type=script&lang=js"
import style0 from "./TimeslotsCrud.vue?vue&type=style&index=0&id=224bc234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224bc234",
  null
  
)

export default component.exports